import React from "react";
import PropTypes from "prop-types";

function EstablishmentOpeningHours(props) {
    const { items, title } = props;

    let content = null;

    content = (
        <div className="module">
            <div className="heading-xs">{title}</div>
            <dl>
                {items.monday && (
                    <>
                        <dt>
                            {ss.i18n._t("EstablishmentApp.OPENINGHOURS_MONDAY")}
                        </dt>
                        <dd>{items.monday}</dd>
                    </>
                )}
                {items.tuesday && (
                    <>
                        <dt>
                            {ss.i18n._t(
                                "EstablishmentApp.OPENINGHOURS_TUESDAY"
                            )}
                        </dt>
                        <dd>{items.tuesday}</dd>
                    </>
                )}
                {items.wednesday && (
                    <>
                        <dt>
                            {ss.i18n._t(
                                "EstablishmentApp.OPENINGHOURS_WEDNESDAY"
                            )}
                        </dt>
                        <dd>{items.wednesday}</dd>
                    </>
                )}
                {items.thursday && (
                    <>
                        <dt>
                            {ss.i18n._t(
                                "EstablishmentApp.OPENINGHOURS_THURSDAY"
                            )}
                        </dt>
                        <dd>{items.thursday}</dd>
                    </>
                )}
                {items.friday && (
                    <>
                        <dt>
                            {ss.i18n._t("EstablishmentApp.OPENINGHOURS_FRIDAY")}
                        </dt>
                        <dd>{items.friday}</dd>
                    </>
                )}
                {items.saturday && (
                    <>
                        <dt>
                            {ss.i18n._t(
                                "EstablishmentApp.OPENINGHOURS_SATURDAY"
                            )}
                        </dt>
                        <dd>{items.saturday}</dd>
                    </>
                )}
                {items.sunday && (
                    <>
                        <dt>
                            {ss.i18n._t("EstablishmentApp.OPENINGHOURS_SUNDAY")}
                        </dt>
                        <dd>{items.sunday}</dd>
                    </>
                )}
            </dl>
            {items.comments && (
                <div className="text-info">{`${items.comments}`}</div>
            )}
        </div>
    );

    return <>{content}</>;
}

EstablishmentOpeningHours.propTypes = {
    items: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
};

export default EstablishmentOpeningHours;
